import { isPromise } from "../../fn";

/**
 * Creates Context Initialization decorator for GqlFetcher
 */
const contextMiddleware = initializer => next => (operation, context) => {
	const runNext = newContext => next(operation, newContext ?? context);

	try {
		const initResult = initializer(context, operation);
		return isPromise(initResult) ? initResult.then(runNext) : runNext(initResult);
	} catch (err) {
		return Promise.reject(err);
	}
};

export default contextMiddleware;
